import axios from 'axios';
import { authHeader } from './authservice/auth-header';

// const ELASTIC_API = process.env.VUE_APP_ELASTIC_API;
const BASE_API = process.env.VUE_APP_BASE_API_URL;

class CitizenService {
    search(ip, data) {
        return axios.post(ip+'minduk/_search?scroll=10m', data, { headers: {'Content-Type': 'application/json'} });
    }
    searchByNIK(ip, data) {
        return axios.post(ip+'minduk/_search?filter_path=hits.hits._source', data, { headers: {'Content-Type': 'application/json'} });
    }
    create(data) {
        return axios.post(BASE_API + 'socmed/ct', data, { headers: authHeader() });
    }
    delete(id) {
        return axios.delete(BASE_API + 'socmed/ct/'+id, { headers: authHeader() });
    }
    
}

export default new CitizenService();
